import { t, useLanguage } from "@/i18n/LanguageContext";import { useSite } from "@/context/SiteContext";
import { Eyebrow, DecorativeStripe } from "@/components/Reveal";
import { BimProjects } from "@/components/BimProjects";

export default function Bim() {useLanguage();
  const { content } = useSite();
  return <main data-testid="bim-page">
    <section className="relative bg-[#F8FAFC] py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Eyebrow>{t("Progettazione BIM · Revit · Autodesk")}</Eyebrow>
        <h1 data-testid="bim-projects-title" className="mt-4 max-w-4xl font-display text-4xl font-bold tracking-tight text-brand-navydeep sm:text-5xl lg:text-6xl">{t(content.bim.title)}</h1>
        <span aria-hidden="true" className="mt-7 block h-px w-16 bg-brand-amber" />
        <p data-testid="bim-projects-description" className="mt-6 max-w-3xl leading-relaxed text-slate-600">{t(content.bim.description)}</p>
        <p data-testid="bim-projects-disclaimer" className="mt-5 max-w-3xl text-xs leading-relaxed text-slate-500">{t(content.bim.disclaimer)}</p>
      </div>
      <DecorativeStripe testId="bim-header-decorative-stripe" />
    </section>
    <BimProjects />
  </main>;
}
